module.exports = "../../app/cells/components/modals/setup_wizard/course_selection.erb";